import { faLeaf, faSignOut } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef, useEffect,useState } from "react";
import { useLocation } from 'react-router-dom';
import initMenus from "../../data/menus.js";
import "./sidebar.css";
import SidebarLogo from "./SidebarLogo.jsx";
// import SidebarSearch from "./SidebarSearch.jsx";
import { Link } from "react-router-dom";
import Loader from "../../components/Loader.js";
import { sidebarToggle } from "../../utils/toggler.js";

import MenuList from "./MenuList.jsx";
import { useNavigate } from "react-router-dom";
import logo from "../../images/logo.png";
import { logout } from "../../api/user/index.js";
import { toast } from "react-toastify";
import { event } from "../../utils/event";

function Sidebar({ ...props }) {
  const navigate = useNavigate();
  const [menus, setMenus] = useState(initMenus);
  const [scButton, setScButton] = useState(false);
  const search = useRef("");
  const token = JSON.parse(localStorage.getItem("accessToken"));
  const [loading, setLoading] = useState(false); // State for controlling the loader
  const [isDisabled, setIsDisabled] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const hiddenSidebarRoutes = ['/', '/auth/register', '/auth/login', '/auth/verification','/auth/forgot-password'];
  const shouldHideSidebar = hiddenSidebarRoutes.includes(location.pathname);

  const handleChange = (e) => {
    if (e.target.value) {
      setScButton(true);
      setMenus(
        menus.filter((el) => {
          return el.label.toLowerCase().includes(e.target.value.toLowerCase());
        })
      );
    } else {
      setScButton(false);
      setMenus(initMenus);
    }
  };

  const clearSearch = () => {
    search.current.value = "";
    setMenus(initMenus);
    setScButton(false);
  };

  const logoutUser = async () => {
    setIsDisabled(true);
    try {
      setLoading(true); // Set loading to true when starting logout process
      const response = await logout(); // Assuming logout is an async function that returns a promise
      if (response.data.success && response.data.status === 200) {
        // toast.success(response.data.message)
        const opt = () => {
          localStorage.removeItem("ticker");
          localStorage.removeItem("deviceId");
          localStorage.removeItem("searchItem");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("google_login");
          localStorage.removeItem("isVerified");
          localStorage.removeItem("img");
          localStorage.removeItem("user_id");
          localStorage.removeItem("chartSettings");
          localStorage.removeItem("userEmail");
          localStorage.removeItem("notificationCount");
          localStorage.removeItem("messageCount");
          localStorage.removeItem("FCM-WEB");
          localStorage.removeItem("gameurl");
        };
        // Wait for 2 seconds before reloading and navigating
        await new Promise((resolve) => setTimeout(resolve, 2000));
        setTimeout(() => {
          setIsDisabled(false);
        }, 2000);
        opt();
        setLoading(false);
        // window.location.reload();
        sidebarToggle();
        navigate("/");
        // Handle successful logout
      } else if (response.data.status === 400) {
        // Handle logout failure
        // navigate("/")
        setIsDisabled(false);
        toast.error("Logout failed");
        // console.log("Logout failed");
      }
    } catch (error) {
      // Handle other errors
      // navigate("/")
      setIsDisabled(false);
      toast.error("Logout failed");
      console.error("Error during logout:", error);
    }
  };

  useEffect(() => {
    // Check if the URL contains '/:slug/' pattern
    const isDynamicRoute = /\/[^/]+\/(buysell|portfolio|leaderboard|profile|charts|feeds|chatHistory|create-feed|edit-feed|followers)/.test(location.pathname);
    setIsCollapsed(isDynamicRoute);
  }, [location]);

  // Call the function when you want to logout
  return (
    <>
{!shouldHideSidebar && (
  <aside
    id="sidebar"
    className={`sidebarWrapper md:translate-x-0 -translate-x-full md:z-0 z-50 no-scrollbar post ${props.className} ${isCollapsed ? "md:!w-20" : "md:!w-64"}`}
    style={{ position: "fixed" }}
  >
    <div className={`border-r-2 border-gray-100 h-full flex-col flex flex-shrink-0 ${isCollapsed ? "md:w-20" : "md:w-64"}`}>
      <div className="flex justify-center items-center my-2">
        <Link to="/feed" className="px-2">
          <img src={"/qushi_logo.png"} className="max-h-24" alt="Qushi" />
        </Link>
      </div>

      <MenuList isCollapsed={isCollapsed} menus={menus} toggle={props.toggle} />

      <div className="pt-2 border-t border-gray-300">
        <div className="py-2 px-4">
          {token ? (
            <button
              disabled={isDisabled}
              className="py-2 px-4 border border-primaryColor bg-primaryColor w-full rounded-full text-gray-200 justify-end text-sm"
              onClick={() => {
                event("LogOutUser");
                logoutUser();
              }}
            >
              <FontAwesomeIcon icon={faSignOut} /> {!isCollapsed && "Logout"}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  </aside>
)}

      {loading && <Loader />}

      {props.className === "mobile" && (
        <div
          id="overlaySidebar"
          onClick={props.toggle}
          className="hidden absolute w-full h-screen bg-black z-10 inset-0 opacity-60"
        >
          <div></div>
        </div>
      )}
    </>
  );
}

export default Sidebar;
